import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaSpinner, FaTimes, FaUser } from "react-icons/fa";
import AvailableDriversService from "../services/AvailableDriversService";

const STATUS_LABELS = {
  both: "Both",
  online: "Online",
  offline: "Offline",
};

const AvailableDriversCellModal = ({ show, day, pincode, hour, hourLabel, status = "both", onClose }) => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [evaluationDay, setEvaluationDay] = useState(day);

  useEffect(() => {
    if (!show || !pincode || hour === undefined || hour === null) return;

    let cancelled = false;

    const fetchDrivers = async () => {
      setLoading(true);
      setDrivers([]);
      try {
        const response = await AvailableDriversService.getAvailableDriversForCell({
          day,
          pincode,
          hour,
          status,
        });
        if (cancelled) return;
        if (response?.success) {
          setDrivers(response.data?.drivers || []);
          setEvaluationDay(response.data?.evaluationDay || day);
        } else {
          setDrivers([]);
        }
      } catch {
        if (!cancelled) setDrivers([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchDrivers();

    return () => {
      cancelled = true;
    };
  }, [show, day, pincode, hour, status]);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 py-4 border-b border-gray-200 flex justify-between items-start gap-3 shrink-0">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Available Drivers
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              {STATUS_LABELS[status] || "Both"}
              {" · "}
              Pincode <span className="font-medium text-gray-800">{pincode}</span>
              {" · "}
              {hourLabel}
              {" · "}
              {evaluationDay}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 p-1 shrink-0"
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        <div className="overflow-y-auto flex-1 min-h-0 max-h-[60vh] px-5 py-4">
          {loading ? (
            <div className="flex items-center justify-center py-10 text-gray-500">
              <FaSpinner className="animate-spin mr-2" />
              Loading drivers...
            </div>
          ) : drivers.length === 0 ? (
            <p className="text-center text-sm text-gray-500 py-10">
              No drivers found for this slot.
            </p>
          ) : (
            <ul className="divide-y divide-gray-100">
              {drivers.map((driver) => (
                <li
                  key={driver._id}
                  className="py-3 flex items-start gap-3 first:pt-0 last:pb-0"
                >
                  <div className="mt-0.5 text-blue-600 shrink-0">
                    <FaUser className="text-sm" />
                  </div>
                  <div className="min-w-0 flex-1">
                    {/* <Link
                      to={`/drivers/detail/${driver._id}`}
                      className="text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline block truncate"
                      onClick={onClose}
                    >
                      {driver.fullName || "Unknown"}
                    </Link> */}
                     <h5
                     className="text-sm font-medium text-blue-600 hover:text-blue-800 block truncate"
                    >
                      {driver.fullName || "Unknown"}
                    </h5>
                    <p className="text-sm text-gray-600 mt-0.5 break-all">
                      {driver.phone || "—"}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {!loading && drivers.length > 0 && (
          <div className="px-5 py-3 border-t border-gray-200 shrink-0">
            <p className="text-xs text-gray-500 text-center">
              {drivers.length} driver{drivers.length !== 1 ? "s" : ""} available
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AvailableDriversCellModal;
